module.exports = __webpack_public_path__ + "img/OBCINA SENTILJ.56533224.png";